import { noop } from 'lodash';

import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';
import { VisitUpdateRecommendationsCommand } from '@dreryk/egabinet-visit-frontend-api';

import { TextEditorValue } from '@dreryk/react-text-editor';
import { FieldController } from '@dreryk/react-common';
import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';
import { StyledFlex } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { VisitFormTextEditor } from '../shared/VisitFormTextEditor';
import { recommendationsTranslationKeys } from '../../../translations';

import { RecommendationsSendLink } from './RecommendationsSendLink';
import { RecommendationsPrintLink } from './RecommendationsPrintLink';

type RecommendationsTextEditorProps = {
   readonly controller: FieldController<TextEditorValue | null>;
   readonly practitionerId: PractitionerId;
   readonly visitId: number;
   readonly patientId: number;
};

export const RecommendationsTextEditor = (props: RecommendationsTextEditorProps): JSX.Element => {
   const { executeAsync: updateRecommendations } = useCqrsCommand<void, { value: TextEditorValue | null }>(
      ({ value }) => {
         const command = new VisitUpdateRecommendationsCommand();
         command.id = props.visitId;
         command.recommendations = Choice.withUseDefaultIfNull(value?.getFormattedValue() ?? null);
         return command;
      },
      {
         onUnexpectedError: noop,
      }
   );

   return (
      <VisitFormTextEditor
         testId={'recommendations'}
         placeholder={recommendationsTranslationKeys.field.placeholder}
         modalLabel={recommendationsTranslationKeys.field.label}
         label={recommendationsTranslationKeys.field.label}
         labelSuffix={
            <StyledFlex gap={8}>
               {protectFeature(
                  'sendingDocumentsToPatient',
                  <RecommendationsSendLink patientId={props.patientId} visitId={props.visitId} />
               )}
               <RecommendationsPrintLink visitId={props.visitId} />
            </StyledFlex>
         }
         controller={props.controller}
         practitionerId={props.practitionerId}
         onAutoSave={updateRecommendations}
      />
   );
};
